import {
  type MutationFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { EmailTemplate } from 'utils/types';

import { EMAIL_TEMPLATE_FORM } from '../forms/schema';
import c from '../utils/constants';

export default function useUpdateEmailTemplate() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  const mutationFn: MutationFunction<
    { data: EmailTemplate },
    EMAIL_TEMPLATE_FORM & { id: string }
  > = async (payload) => {
    const api = new Api(args);
    const data = await api.put(
      await withAcl({
        account: {
          url: `api/v1/channels/email/templates/${payload.id}`,
          payload,
        },
        admin: {
          // eslint-disable-next-line max-len
          url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/email/templates/${payload.id}`,
          payload,
        },
      }),
    );

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [c.TEMPLATES, {}] });
      queryClient.setQueryData([c.TEMPLATES, data.data._id], () => data.data);

      toastSuccess('Successfully updated email template');
    },
  });
}
